import { useState } from "react";
import { Link } from "react-router";
import { authClient } from "../../lib/auth-client";
import { useSession } from "../../lib/SessionContext";

type Modo = "password" | "magic-link";

export function LoginForm() {
  const { recargar } = useSession();
  const [modo, setModo] = useState<Modo>("password");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [aviso, setAviso] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setAviso(null);
    setEnviando(true);

    // El cliente de Better Auth DEVUELVE { error }, no tira. Un try/catch aca
    // no veria nada y el formulario quedaria mudo ante credenciales malas.
    if (modo === "password") {
      const res = await authClient.signIn.email({ email, password });
      if (res.error) {
        setError(res.error.message ?? "No pudimos iniciar sesion.");
      } else {
        await recargar();
      }
    } else {
      const res = await authClient.signIn.magicLink({ email });
      if (res.error) {
        setError(res.error.message ?? "No pudimos enviar el enlace.");
      } else {
        setAviso("Te enviamos un enlace de acceso. Revisa tu correo.");
      }
    }

    setEnviando(false);
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm space-y-5 rounded-lg border border-neutral-200 bg-white p-8"
      >
        <div>
          <h1 className="text-xl font-semibold text-neutral-900">PrintFlow</h1>
          <p className="mt-1 text-sm text-neutral-600">Ingresa para continuar.</p>
        </div>

        <label className="block">
          <span className="text-sm text-neutral-700">Email</span>
          <input
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded border border-neutral-300 bg-neutral-50 px-3 py-2 text-neutral-900"
          />
        </label>

        {modo === "password" && (
          <label className="block">
            <span className="text-sm text-neutral-700">Contraseña</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full rounded border border-neutral-300 bg-neutral-50 px-3 py-2 text-neutral-900"
            />
          </label>
        )}

        {modo === "password" && (
          <Link to="/olvide-contrasena" className="block text-sm text-neutral-600 underline">
            ¿Olvidaste tu contraseña?
          </Link>
        )}

        {error && (
          <p role="alert" className="text-sm text-red-400">
            {error}
          </p>
        )}
        {aviso && <p className="text-sm text-emerald-400">{aviso}</p>}

        <button
          type="submit"
          disabled={enviando}
          className="w-full rounded bg-neutral-900 px-3 py-2 font-medium text-neutral-100 disabled:opacity-50"
        >
          {enviando ? "..." : modo === "password" ? "Ingresar" : "Enviar enlace"}
        </button>

        <button
          type="button"
          onClick={() => {
            setModo(modo === "password" ? "magic-link" : "password");
            setError(null);
            setAviso(null);
          }}
          className="w-full text-sm text-neutral-600 underline"
        >
          {modo === "password" ? "Ingresar con un enlace por email" : "Ingresar con contrasena"}
        </button>
      </form>
    </div>
  );
}
